let ipcRendererSafe = null
let remoteSafe = null
const isElectron = process && process.versions && process.versions.electron

try {
  if (!isElectron) throw new Error('Not in Electron context')
  const electron = require('electron')
  ipcRendererSafe = electron?.ipcRenderer
  remoteSafe = electron?.remote
} catch (e) {
  // Not in Electron context
  ipcRendererSafe = null
  remoteSafe = null
}

export const debugLog = (...args) => {
  if (ipcRendererSafe) {
    ipcRendererSafe.send('electron-log', ...args)
    return
  }
}

export const closeApp = () => {
  if (!ipcRendererSafe) return
  ipcRendererSafe.send('close-app')
}

export const minimizeWindow = () => {
  if (!remoteSafe) return
  remoteSafe.BrowserWindow.getFocusedWindow().minimize()
}

export const maximizeWindow = () => {
  if (!remoteSafe) return false
  const window = remoteSafe.getCurrentWindow()
  if (window.isMaximized()) {
    window.unmaximize()
    return false
  }
  window.maximize()
  return true
}

export const isMaximized = () => {
  if (!remoteSafe) return false
  const window = remoteSafe.getCurrentWindow()
  return window.isMaximized()
}
